import React, { useEffect, useState } from "react";
import { useStateValue } from "../../Registration/Components/ContextAPI/StateProvider";
import Slider from "@material-ui/core/Slider";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const DeviceSettingGPSLeft = ({ planid }) => {
  const [
    {
      devicesettinggps,
      globalalert,
      serviceProvider,
      activationType,
      servicerules,
    },
    dispatch,
  ] = useStateValue();
  const [speedvalue, setspeedvalue] = useState(devicesettinggps.speed_limit);
  const [tripvalue, settripvalue] = useState(devicesettinggps.trip_end_timer);
  const [secondarynumber, setsecondarynumber] = useState(false);
  const [batteryvalue, setbatteryvalue] = useState(
    devicesettinggps.battery_low_limit
  );
  const [soserror, setsoserror] = useState(false);
  const [secondaryerror, setsecondaryerror] = useState(false);
  const [gsensorerror, setgsensorerror] = useState(false);

  const [snackbar, setsnackbar] = useState(false);
  const [snacksosbar, setsnacksosbar] = useState(false);

  useEffect(() => {
    setspeedvalue(devicesettinggps.speed_limit);
    settripvalue(devicesettinggps.trip_end_timer);
    setbatteryvalue(devicesettinggps.battery_low_limit);
  }, [devicesettinggps]);

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (planid) {
      let bool = planfuncchk("allow_second_phone_number");
      let bool2 = planfuncchk("sos_button");
      let bool3 = planfuncchk("gsensor_enable");
      setsoserror(bool2);
      setgsensorerror(bool3);
      setsecondaryerror(bool);
    }
  }, [planid]);

  const marks = [
    {
      value: 0,
      label: `0 ${activationType.unit}`,
    },
    {
      value: 300,
      label: `300 ${activationType.unit}`,
    },
  ];
  const marks2 = [
    {
      value: 0,
      label: "0 Min",
    },
    {
      value: 10,
      label: "10 Min",
      className: "shiftright",
    },
  ];
  const batterymarks = [
    {
      value: 0,
      label: "0 %",
    },
    {
      value: 100,
      label: "100 %",
    },
  ];

  function valuetext(value) {
    return `${value} ${activationType.unit}`;
  }
  function valuetext2(value) {
    return `${value} Min`;
  }
  function batterytext(value) {
    return `${value} %`;
  }

  const changeglobalsetting = (e) => {
    devicesettinggps.trip_email = e.target.checked;
    devicesettinggps.trip_notification = e.target.checked;
    devicesettinggps.trip_notification_global = e.target.checked;
    devicesettinggps.trip_sms = e.target.checked;

    devicesettinggps.speed_email = e.target.checked;
    devicesettinggps.speed_notification = e.target.checked;
    devicesettinggps.speed_notification_global = e.target.checked;
    devicesettinggps.speed_sms = e.target.checked;

    devicesettinggps.power_email = e.target.checked;
    devicesettinggps.power_notification = e.target.checked;
    devicesettinggps.power_notification_global = e.target.checked;
    devicesettinggps.power_sms = e.target.checked;

    devicesettinggps.battery_notification_global = e.target.checked;
    devicesettinggps.battery_email = e.target.checked;
    devicesettinggps.battery_notification = e.target.checked;
    devicesettinggps.battery_sms = e.target.checked;
    if (!soserror) {
      devicesettinggps.sos_notification_global = e.target.checked;
      devicesettinggps.sos_notification = e.target.checked;
      devicesettinggps.sos_email = e.target.checked;
      devicesettinggps.sos_sms = e.target.checked;
    }

    devicesettinggps.charging_notification_global = e.target.checked;
    devicesettinggps.charging_notification = e.target.checked;
    devicesettinggps.charging_email = e.target.checked;
    devicesettinggps.charging_sms = e.target.checked;

    devicesettinggps.global_email = e.target.checked;
    devicesettinggps.global_notification = e.target.checked;
    devicesettinggps.global_sms = e.target.checked;
    callreducer(devicesettinggps);
    dispatch({
      type: "ADD_TO_GLOBALALERT",
      globalalert: e.target.checked,
    });
  };
  const changeglobalemail = (e) => {
    devicesettinggps.trip_email = e.target.checked;
    devicesettinggps.speed_email = e.target.checked;
    devicesettinggps.power_email = e.target.checked;
    devicesettinggps.battery_email = e.target.checked;
    if (!soserror) devicesettinggps.sos_email = e.target.checked;
    devicesettinggps.charging_email = e.target.checked;
    devicesettinggps.global_email = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalnotification = (e) => {
    devicesettinggps.global_notification = e.target.checked;
    devicesettinggps.charging_notification = e.target.checked;
    if (!soserror) devicesettinggps.sos_notification = e.target.checked;
    devicesettinggps.battery_notification = e.target.checked;
    devicesettinggps.power_notification = e.target.checked;
    devicesettinggps.speed_notification = e.target.checked;
    devicesettinggps.trip_notification = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalsms = (e) => {
    devicesettinggps.trip_sms = e.target.checked;
    devicesettinggps.speed_sms = e.target.checked;
    devicesettinggps.power_sms = e.target.checked;
    devicesettinggps.battery_sms = e.target.checked;
    if (!soserror) devicesettinggps.sos_sms = e.target.checked;
    devicesettinggps.charging_sms = e.target.checked;
    devicesettinggps.global_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobaltrip = (e) => {
    devicesettinggps.trip_email = e.target.checked;
    devicesettinggps.trip_notification = e.target.checked;
    devicesettinggps.trip_notification_global = e.target.checked;
    devicesettinggps.trip_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalspeed = (e) => {
    devicesettinggps.speed_email = e.target.checked;
    devicesettinggps.speed_notification = e.target.checked;
    devicesettinggps.speed_notification_global = e.target.checked;
    devicesettinggps.speed_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalpower = (e) => {
    devicesettinggps.power_email = e.target.checked;
    devicesettinggps.power_notification = e.target.checked;
    devicesettinggps.power_notification_global = e.target.checked;
    devicesettinggps.power_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalbattery = (e) => {
    devicesettinggps.battery_email = e.target.checked;
    devicesettinggps.battery_notification = e.target.checked;
    devicesettinggps.battery_notification_global = e.target.checked;
    devicesettinggps.battery_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalsos = (e) => {
    if (soserror) {
      setsnacksosbar(true);
      return;
    }
    devicesettinggps.sos_email = e.target.checked;
    devicesettinggps.sos_notification = e.target.checked;
    devicesettinggps.sos_notification_global = e.target.checked;
    devicesettinggps.sos_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const changeglobalcharging = (e) => {
    devicesettinggps.charging_email = e.target.checked;
    devicesettinggps.charging_notification = e.target.checked;
    devicesettinggps.charging_notification_global = e.target.checked;
    devicesettinggps.charging_sms = e.target.checked;
    callreducer(devicesettinggps);
  };
  const inputEvent = (e) => {
    const name = e.target.name;
    if (
      name === "sos_notification" ||
      name === "sos_email" ||
      name === "sos_sms"
    ) {
      if (soserror) {
        setsnacksosbar(true);
        return;
      }
    }
    devicesettinggps[`${name}`] = e.target.checked;
    callreducer(devicesettinggps);
  };
  const inputEvent2 = (e) => {
    const name = e.target.name;
    if (name === "secondary_phone" || name === "phone") {
      if (e.target.value.length > 10 || Number.isNaN(Number(e.target.value))) {
        return;
      }
      devicesettinggps[`${name}`] = e.target.value.trim();
    } else {
      devicesettinggps[`${name}`] = e.target.value;
    }
    callreducer(devicesettinggps);
  };
  const handleChange = (event, newvalue) => {
    setspeedvalue(newvalue);
    devicesettinggps.speed_limit = newvalue;
    callreducer(devicesettinggps);
  };
  const handletripChange = (event, newvalue) => {
    settripvalue(newvalue);
    devicesettinggps.trip_end_timer = newvalue;
    callreducer(devicesettinggps);
  };
  const handlebatteryChange = (event, newvalue) => {
    setbatteryvalue(newvalue);
    devicesettinggps.battery_low_limit = newvalue;
    callreducer(devicesettinggps);
  };
  const handlesensorchange = (event) => {
    devicesettinggps.trip_sensor = event.target.checked;
    devicesettinggps.trip_coordinate = !event.target.checked;
    callreducer(devicesettinggps);
  };
  const handlecoordinatechange = (event) => {
    devicesettinggps.trip_sensor = !event.target.checked;
    devicesettinggps.trip_coordinate = event.target.checked;
    callreducer(devicesettinggps);
  };
  const changeOdometer = (event) => {
    dispatch({
      type: "ADD_TO_ODOMETERVALUE",
      odometer_value: event.target.value,
    });
  };

  const callreducer = (val) => {
    dispatch({
      type: "ADD_TO_DEVICESETTINGS_GPS",
      devicesetting: val,
    });
  };
  const checksecondarynumber = () => {
    if (secondaryerror) {
      setsnackbar(true);
      return;
    }
    setsecondarynumber(true);
  };

  const planfuncchk = (type) => {
    if (servicerules[planid] && servicerules[planid]["rules"]) {
      if (servicerules[planid]["rules"].search(type) !== -1) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };
  const handlesnackbar = () => {
    setsnackbar(false);
    setsnacksosbar(false);
  };
  const renderTooltip = (props) => (
    <Tooltip id="tooltip" {...props}>
      <div>
        Generates alert when device sense motion.Even touching the device also
        will generate alert.
      </div>
    </Tooltip>
  );
  const updateplan = () => {
    window.open(
      `https://amcrestgps.net/gps-activation/#/device-plan/update?customer_id=${devicesettinggps["customer_id"]}`,
      "_blank"
    );
  };
  return (
    <div style={{ marginLeft: "50px" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar}
        autoHideDuration={6000}
        onClose={handlesnackbar}
      >
        <Alert onClose={handlesnackbar} severity="error">
          Upgrade your plan to enable secondary phone number !
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snacksosbar}
        autoHideDuration={6000}
        onClose={handlesnackbar}
      >
        <Alert onClose={handlesnackbar} severity="error">
          Upgrade your plan to enable SOS Services !
        </Alert>
      </Snackbar>
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>IMEI:</strong>
          </div>
          <div className="col-md-8">
            <input
              value={devicesettinggps.imei}
              name="imei"
              type="text"
              placeholder="Device Name"
              readOnly
              className="form-control devicesettingleft_text"
            />
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Device Name:</strong>
          </div>
          <div className="col-md-8">
            <input
              value={devicesettinggps.device_name}
              name="device_name"
              onChange={inputEvent2}
              type="text"
              placeholder="Device Name"
              className="form-control devicesettingleft_text"
            />
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Alert Email Alerts:</strong>
          </div>
          <div className="col-md-8">
            <input
              name="email"
              value={devicesettinggps.email}
              onChange={inputEvent2}
              type="text"
              placeholder="Leave blank to disable"
              className="form-control devicesettingleft_text"
            />
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Mobile Carrier Primary:</strong>
          </div>
          <div className="col-md-8">
            <select
              className="form-control devicesettingleft_select"
              name="mobile_carrier"
              value={devicesettinggps.mobile_carrier}
              onChange={inputEvent2}
            >
              <option value="">Select Mobile Carrier</option>
              {serviceProvider?.map((item, index) => (
                <option key={index + 1} value={item.mobile_provider_name}>
                  {item.mobile_provider_name}
                </option>
              ))}
            </select>
            {!devicesettinggps.mobile_carrier && (
              <span className="errormessage">
                <span>
                  <i className="fa fa-times errorifont" aria-hidden="true"></i>
                </span>
                Select your mobile carrier
              </span>
            )}
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Alert SMS/Text Primary:</strong>
          </div>
          <div className="col-md-8">
            <input
              name="phone"
              value={devicesettinggps.phone}
              onChange={inputEvent2}
              type="text"
              placeholder="Leave blank to disable"
              className="form-control devicesettingleft_text"
            />
            <p className="marginp devicesettingpfooter">
              ✱ Phone should be 10 digit without country code and hyphen!
            </p>
            <p className="phone_instruction2">
              * By providing your phone number, you are opting in to receive SMS
              alerts from{" "}
              <a
                target="_blank"
                href="https://amcrestgps.net/terms/"
                rel="noreferrer"
                className="termslink"
              >
                amcrestgps.net.
              </a>
            </p>
          </div>
        </div>
        {!secondarynumber ? (
          <div className="row marginrow">
            <div className="col-md-5 textalignleft">
              <strong>Alert SMS/Text Secondary:</strong>
            </div>
            <div className="col-md-7">
              <button
                className="btn"
                style={{ backgroundColor: "#3f51b5", color: "white" }}
                onClick={checksecondarynumber}
                // onClick={() => setsecondarynumber(true)}
              >
                + Add Secondary Phone Number
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="row marginrow">
              <div className="col-md-4 textalignleft">
                <strong>Mobile Carrier Secondary:</strong>
              </div>
              <div className="col-md-8">
                <select
                  name="secondary_mobile_carrier"
                  value={devicesettinggps.secondary_mobile_carrier}
                  onChange={inputEvent2}
                  className="form-control devicesettingleft_select"
                >
                  <option value="">Select Mobile Carrier</option>
                  {serviceProvider?.map((item, index) => (
                    <option key={index + 1} value={item.mobile_provider_name}>
                      {item.mobile_provider_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row marginrow">
              <div className="col-md-4 textalignleft">
                <strong>Alert SMS/Text Secondary:</strong>
              </div>
              <div className="col-md-8">
                <input
                  name="secondary_phone"
                  value={devicesettinggps.secondary_phone}
                  onChange={inputEvent2}
                  type="text"
                  placeholder="Leave blank to disable"
                  className="form-control devicesettingleft_text"
                />
              </div>
            </div>
          </>
        )}
        {secondaryerror && (
          <span className="upgradeplantext" onClick={updateplan}>
            Upgrade your plan to enable secondary phone number !
          </span>
        )}
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>All Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalsetting(e)}
              checked={globalalert}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>All Push Notification Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalnotification(e)}
              checked={devicesettinggps.global_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>All Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalemail(e)}
              checked={devicesettinggps.global_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>All SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalsms(e)}
              checked={devicesettinggps.global_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Trip Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              name="trip_notification_global"
              onChange={(e) => changeglobaltrip(e)}
              checked={devicesettinggps.trip_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Trip Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              name="trip_notification"
              onChange={inputEvent}
              checked={devicesettinggps.trip_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Trip Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              name="trip_email"
              onChange={inputEvent}
              checked={devicesettinggps.trip_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Trip SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              name="trip_sms"
              onChange={inputEvent}
              checked={devicesettinggps.trip_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div>
          <p style={{ fontWeight: 600 }}>Trip Start/Stop Alerts by:</p>
          <div className="row m-0">
            <div className="col-md-7 px-1">
              <input
                type="radio"
                id="sensor"
                onChange={handlesensorchange}
                name="trip_stop"
                checked={devicesettinggps.trip_sensor}
              />
              <label className="font-weight-bold mb-0" for="sensor">
                G-Sensor Movement{gsensorerror && "(Email Only)"}{" "}
                <OverlayTrigger
                  delay={{ show: 100, hide: 250 }}
                  overlay={renderTooltip}
                >
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </OverlayTrigger>
              </label>
              {gsensorerror && (
                <span className="upgradeplantext" onClick={updateplan}>
                  Upgrade your plan to enable
                  <br /> G-Sensor SMS Alerts !
                </span>
              )}
            </div>
            <div className="col-md-5">
              <input
                type="radio"
                id="coordinate"
                onChange={handlecoordinatechange}
                name="trip_stop"
                checked={devicesettinggps.trip_coordinate}
              />
              <label className="font-weight-bold" for="coordinate">
                Coordinate Change
              </label>
              <br />
            </div>
          </div>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Speed Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalspeed(e)}
              checked={devicesettinggps.speed_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Speed Push Notification:</p>
          <label className="toggleswitch">
            <input
              onChange={inputEvent}
              name="speed_notification"
              type="checkbox"
              checked={devicesettinggps.speed_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Speed Email Alerts:</p>
          <label className="toggleswitch">
            <input
              onChange={inputEvent}
              name="speed_email"
              type="checkbox"
              checked={devicesettinggps.speed_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Speed SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              onChange={inputEvent}
              name="speed_sms"
              type="checkbox"
              checked={devicesettinggps.speed_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p style={{ flex: ".3" }}>Speed Limit:</p>
          <Slider
            style={{ flex: ".7", marginRight: "10px" }}
            value={speedvalue || ""}
            valueLabelDisplay="on"
            getAriaValueText={valuetext}
            aria-labelledby="discrete-slider-custom"
            onChange={handleChange}
            max={300}
            marks={marks}
          />
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Power On/Off Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalpower(e)}
              checked={devicesettinggps.power_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Power On/Off Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="power_notification"
              checked={devicesettinggps.power_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Power On/Off Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="power_email"
              checked={devicesettinggps.power_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Power On/Off SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="power_sms"
              checked={devicesettinggps.power_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Battery Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalbattery(e)}
              checked={devicesettinggps.battery_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Battery Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="battery_notification"
              checked={devicesettinggps.battery_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Battery Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="battery_email"
              checked={devicesettinggps.battery_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Battery SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="battery_sms"
              checked={devicesettinggps.battery_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p style={{ flex: ".3" }}>Low Battery & Alert ≤:</p>
          <Slider
            style={{ flex: ".7", marginRight: "10px" }}
            value={batteryvalue || ""}
            valueLabelDisplay="on"
            getAriaValueText={batterytext}
            aria-labelledby="discrete-slider-custom"
            onChange={handlebatteryChange}
            max={100}
            marks={batterymarks}
          />
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>SOS/Emergency Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalsos(e)}
              checked={devicesettinggps.sos_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>SOS/Emergency Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="sos_notification"
              checked={devicesettinggps.sos_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>SOS/Emergency Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="sos_email"
              checked={devicesettinggps.sos_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>SOS/Emergency SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="sos_sms"
              checked={devicesettinggps.sos_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        {soserror && (
          <span className="upgradeplantext" onClick={updateplan}>
            Upgrade your plan to enable SOS Alert !
          </span>
        )}
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <div className="devicesetting_alert">
          <p>
            <strong>Charging Connected/Disconnected Alerts:</strong>
          </p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={(e) => changeglobalcharging(e)}
              checked={devicesettinggps.charging_notification_global}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Charging Connected/Disconnected Push Notification:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="charging_notification"
              checked={devicesettinggps.charging_notification}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Charging Connected/Disconnected Email Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="charging_email"
              checked={devicesettinggps.charging_email}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
        <div className="devicesetting_alert">
          <p>Charging Connected/Disconnected SMS/Text Alerts:</p>
          <label className="toggleswitch">
            <input
              type="checkbox"
              onChange={inputEvent}
              name="charging_sms"
              checked={devicesettinggps.charging_sms}
            />
            <span className="toggleslider toggleround"></span>
          </label>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Trip End Timer:</strong>
          </div>
          <div className="col-md-8">
            <Slider
              value={tripvalue || ""}
              valueLabelDisplay="on"
              getAriaValueText={valuetext2}
              aria-labelledby="discrete-slider-custom"
              onChange={handletripChange}
              max={10}
              marks={marks2}
            />
          </div>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div className="devicesettingleft">
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Update Odometer:</strong>
          </div>
          <div className="col-md-8 devicesetting_fueldisplay">
            <input
              type="text"
              value={devicesettinggps.odometer_value}
              onChange={changeOdometer}
              placeholder="Enter Odometer Value"
              className="form-control devicesettingleft_text"
            />
            <p style={{ fontWeight: "600" }} className="marginp">
              {activationType.unit === "MPH" ? "Miles" : activationType.unit}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceSettingGPSLeft;
